import { ICSVFormat } from "../../models/csv_format.ts";
import { ILazyAttachment } from "../../models/zip_content.ts";

export const validateInlineImages = (
  csv: ICSVFormat,
  inlineImages: ILazyAttachment[],
): void => {
  const placeholderRegex = /\{\{inline_images\/([^}]+)\}\}/g;
  let match;

  while ((match = placeholderRegex.exec(csv.body)) !== null) {
    const fileName = match[1];
    const found = inlineImages.some((img) => img.name === fileName);
    if (!found) {
      throw new Error(`インライン画像 "${fileName}" が見つかりません`);
    }
  }
};
